<template>
  <salesreturn-check
    :sna-id="snaId"
    :data.sync="checkDataInfo"
    :returnInfo.sync="returninfo"
  >
    <template v-slot:footer>
      <check-module
        :title="`审批信息`"
        v-if="showprevcheck"
      >
        <el-row>
          <el-col :span="8">
            <div class="">申请人：{{checkDataInfo.createUser | isNoData}}</div>
          </el-col>
          <el-col :span="8">
            <div class="">申请时间：{{checkDataInfo.createDate | formatData}}</div>
          </el-col>
          <el-col :span="8">
            <div class="">所属部门：{{checkDataInfo.orgName | isNoData}}</div>
          </el-col>
        </el-row>
      </check-module>
      <check-module :title="`审批`">
        <check-handle-module
          :pass-dialog-txt="`审批通过后销售将执行退货任务。`"
          :check-from-data="checkFromData"
          @submitCheck="submitCheck"
        ></check-handle-module>
      </check-module>
    </template>
  </salesreturn-check>
</template>

<script>
import salesreturnCheck from '@/views/workbench/workCheckManage/salesreturnCheck/salesreturnCheck'
import checkMixin from '@/mixin/checkMixin'
import checkApi from '@/api/workbench/check'

export default {
  name: 'salesreturnCheckView',
  props: {
    showprevcheck: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checkDetailName: 'salesreturncheckdetail',
      returninfo: {}
    }
  },
  components: {
    salesreturnCheck
  },
  mixins: [checkMixin],
  methods: {
    submitCheck (form) {
      const { returninfo } = this
      const params = this.formatCheckParams(form)
      checkApi.submitSalesreturnCheck(Object.assign(params, {
        ...returninfo,
        mark: params.mark
      })).then(res => {
        this.goCheckDetail(res)
      })
    }
  }
}
</script>

<style scoped></style>
